<template>

    <AjanlatBase :titleExtra="titleExtra" v-if="karVisible()">

        <v-form ref="ajanlat-adatok" slot="biztositoi-adatok">

            <v-layout row wrap>

                <BnFormField v-if="karVisible()" :attributes="szgk_utolso_kar_ev"/>

            </v-layout>

        </v-form>

    </AjanlatBase>

</template>

<script>
import BnFormField from '../../../../../../../basecomponents/BnFormField.vue';
import AjanlatBase from '../KGFBAjanlatBase.vue';
import offerData from '../../../../../mixins/ajanlatiadatok/biztosito_specifikus/OfferData';
import TariffAnnouncementUtils from '../../../../../../../../utils/TariffAnnouncementUtils';

export default {
    components: {BnFormField, AjanlatBase},
    mixins: [offerData],
    methods: {
        karVisible() {
            return this.$store.getters.tarifaData.karok.tf_kar_ebben_utoljara_ev > 0
                && this.isKgfbKockakezdetLesser2025;
        },
    },
    computed: {
        isKgfbKockakezdetLesser2025() {
            return TariffAnnouncementUtils.isKockakezdetLesser(2025, 'kgfb', this.$store);
        },
    },
    data() {
        return {
            name: 'AjanlatAdatokB10_V0',
            version: 'v0',
            szgk_utolso_kar_ev: {
                type: 'select',
                label: 'Személygépkocsi gépjármű-kategóriában utolsó károkozás éve',
                visible: true,
                editable: true,
                help: true,
                mezo: 'szgk_utolso_kar_ev',
                path: 'tarifaData.karok.tf_szgk_utolso_kar_ev',
                itemsText: 'value',
                itemsValue: 'key',
                options: [
                    {key: '0', value: 'Nem okoztam kárt'},
                    {key: '2024', value: '2024'},
                    {key: '2023', value: '2023'},
                    {key: '2022', value: '2022'},
                    {key: '2021', value: '2021'},
                    {key: '2020', value: '2020'},
                    {key: '2019', value: '2019'},
                    {key: '2018', value: '2018'},
                    {key: '2017', value: '2017'},
                    {key: '2016', value: '2016'},
                    {key: '2015', value: '2015'},
                    {key: '2014', value: '2014'},
                    {key: '2013', value: '2013'},
                    {key: '1', value: 'Korábban'},
                    {key: '0', value: 'Nem okoztam kárt'},
                ],
            },
        };
    },
};
</script>
